import { render, staticRenderFns } from "./addIUJPnonInti.vue?vue&type=template&id=3b568734&scoped=true&"
import script from "./addIUJPnonInti.vue?vue&type=script&lang=js&"
export * from "./addIUJPnonInti.vue?vue&type=script&lang=js&"
import style0 from "./addIUJPnonInti.vue?vue&type=style&index=0&id=3b568734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b568734",
  null
  
)

export default component.exports